import React, { useState } from "react";
import { TextField, IconButton, Select, MenuItem, FormControl } from "@material-ui/core";
import { Delete as DeleteIcon, Check as CheckIcon } from "@material-ui/icons";

const FIELD_TYPES = [
  { value: "text", label: "Texto" },
  { value: "textarea", label: "Texto longo" },
  { value: "number", label: "Número" },
  { value: "phone", label: "Telefone" },
  { value: "cnpj", label: "CNPJ" },
  { value: "date", label: "Data" },
  { value: "datetime", label: "Data e Hora" },
  { value: "select", label: "Seleção" },
];

const CustomFieldFormFields = ({ field, phases, onSave, onDelete }) => {
  const [name, setName] = useState(field?.name || "");
  const [type, setType] = useState(field?.type || "text");
  const [optionsText, setOptionsText] = useState((field?.options || []).join(", "));
  const [phaseId, setPhaseId] = useState(field?.phaseId || "");
  const isNew = !field;

  const buildOptions = () =>
    optionsText.split(",").map((o) => o.trim()).filter(Boolean);

  const handleSave = () => {
    if (!name.trim()) return;
    if (type === "select" && buildOptions().length === 0) return;
    onSave({
      name,
      type,
      options: type === "select" ? buildOptions() : undefined,
      phaseId: phaseId || null,
    });
    if (isNew) {
      setName("");
      setType("text");
      setOptionsText("");
      setPhaseId("");
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
      <TextField
        size="small"
        variant="outlined"
        placeholder="Nome do campo"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onBlur={!isNew ? handleSave : undefined}
        style={{ minWidth: 160 }}
      />
      <FormControl size="small" variant="outlined">
        <Select value={type} onChange={(e) => setType(e.target.value)} onBlur={!isNew ? handleSave : undefined}>
          {FIELD_TYPES.map((t) => (
            <MenuItem key={t.value} value={t.value}>
              {t.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {type === "select" && (
        <TextField
          size="small"
          variant="outlined"
          placeholder="Opções separadas por vírgula"
          value={optionsText}
          onChange={(e) => setOptionsText(e.target.value)}
          onBlur={!isNew ? handleSave : undefined}
          style={{ minWidth: 200 }}
        />
      )}
      <FormControl size="small" variant="outlined">
        <Select
          value={phaseId}
          onChange={(e) => setPhaseId(e.target.value)}
          onBlur={!isNew ? handleSave : undefined}
          displayEmpty
          style={{ minWidth: 160 }}
        >
          <MenuItem value="">
            <em>Todas as fases</em>
          </MenuItem>
          {(phases || []).map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {isNew ? (
        <IconButton size="small" onClick={handleSave} disabled={!name.trim()}>
          <CheckIcon />
        </IconButton>
      ) : (
        <IconButton size="small" onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default CustomFieldFormFields;
